import { render, staticRenderFns } from "./OtherDelivery.vue?vue&type=template&id=152a11f0"
import script from "./OtherDelivery.vue?vue&type=script&lang=js"
export * from "./OtherDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports